<template>
  <MultipleChoicesDropdown
    title="Product Type"
    :value="value"
    :show-clear-all="false"
    :single-choice="singleChoice"
    :search-enabled="false"
    :choices="choices"
    @change="$emit('change', $event)"
  />
</template>

<script>
import PRODUCT_TYPES from 'services/product-types'

export default {
  props: {
    singleChoice: { type: Boolean, default: true },
    value: {},
  },
  computed: {
    choices: () => PRODUCT_TYPES,
  },
}
</script>
